/** @jsx jsx */
import * as React from 'react';
import { jsx } from '@balance-web/core';
import { DeprecatedButton } from '@balance-web/button-deprecated';
import { Heading } from '@balance-web/heading';
import { Stack } from '@balance-web/stack';
import { Text } from '@balance-web/text';
import { TextLink } from '@balance-web/text-link';
import { CloudOffIcon } from '@balance-web/icon';

import { Fullscreen } from '../../generic/Fullscreen';

export type ErrorScreenProps = {
  title?: string;
  image?: React.ReactNode;
  description?: string;
  refreshButtonLabel?: string;
  onRefreshClick?: () => void;
};

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  title = 'Oops, something went wrong',
  image,
  refreshButtonLabel = 'Refresh Page',
  onRefreshClick,
  children,
  ...props
}) => {
  return (
    <Fullscreen {...props}>
      <Stack gap="xlarge" align="center">
        {image || <CloudOffIcon color="dim" size="large" />}

        <Heading level="4" align="center">
          {title}
        </Heading>

        <Text size="small" color="muted">
          {children || (
            <>
              The issue may be temporary. Please try again. If the problem
              persists, get in touch with our friendly support team.{' '}
              <TextLink href="/settings/help-and-support">
                Learn more ›
              </TextLink>
            </>
          )}
        </Text>

        {onRefreshClick && (
          <DeprecatedButton
            onClick={onRefreshClick}
            size="medium"
            label={refreshButtonLabel}
            block
          />
        )}
      </Stack>
    </Fullscreen>
  );
};
